import * as React from "react";
import { Control, FieldValues } from "react-hook-form";

import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";

import { FormDateField } from "../FormDateField";

interface CoverageEffectiveDateProps<TValues extends FieldValues> {
  control: Control<TValues>;
  disabled?: boolean;
  name: string;
  withHeader?: boolean;
  displayInCard?: boolean;
  hideSubtitle?: boolean;
}

export const CoverageEffectiveDate = <TValues extends FieldValues>({
  control,
  disabled = false,
  name,
  withHeader = true,
  displayInCard = true,
  hideSubtitle = false,
}: CoverageEffectiveDateProps<TValues>) => {
  const FormContent = React.useMemo(
    () => (
      <>
        {withHeader && <CardHeader title="Coverage effective date" />}
        <Box mt={withHeader ? 3 : 0} mb={1}>
          <FormDateField
            id="coverage-effective-date"
            dataTestId="coverage-effective-date"
            name={name}
            control={control}
            disabled={disabled}
          />
        </Box>
        {!hideSubtitle && !disabled && (
          <Typography variant="subtitle1">
            Changing your coverage effective date might affect your premium.
          </Typography>
        )}
      </>
    ),
    [name, control, disabled, withHeader]
  );

  return (
    <Box mt={{ xs: 3, sm: 3 }}>
      {displayInCard ? (
        <Card>
          <CardContent>{FormContent}</CardContent>
        </Card>
      ) : (
        FormContent
      )}
    </Box>
  );
};
